import React from "react";
import { FaGithub, FaLinkedinIn } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";

function Contact() {
  return (
    <>
      <div className="contact text-white pt-20" id="contact">
        <p className="text-3xl text-center mb-8 text-white"></p>
        <div className="flex flex-col bg-[#313131] h-96">
          <div className="flex mx-auto flex-col py-20 text-xl">
            <h6 className="title font-[100] text-center">
              Feel free to contact me for any work or suggestions below
            </h6>
          </div>
          <div className="text-4xl flex mx-auto items-center pb-10">
            <ul className="flex gap-10">
              <a href="https://www.linkedin.com/in/emrhn-gngr/" className="hover:text-blue-900">
                <li>
                  <FaLinkedinIn />
                </li>
              </a>
              <a href="https://x.com/justEmrhn" className="hover:text-blue-500">
                <li>
                  <FaXTwitter />
                </li>
              </a>
              <a href="https://github.com/emrhngngr" className="hover:text-gray-700">
                <li>
                  <FaGithub />
                </li>
              </a>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
}

export default Contact;
